import { Edit2, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '../ui/dialog';
import { FOLDER_COLORS } from '../sidebar/constants';

const EditFolderDialog = ({
  open,
  onOpenChange,
  folderName,
  setFolderName,
  folderColor,
  setFolderColor,
  onSave,
  onDelete,
  loading
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md dark:bg-slate-800 dark:border-slate-700">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 dark:text-gray-100">
            <Edit2 className="w-5 h-5 text-[#4A9CC7]" />
            Edit Folder
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="edit-folder-name" className="dark:text-gray-300">Folder Name</Label>
            <Input
              id="edit-folder-name"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Folder name"
              data-testid="edit-folder-name-input"
              className="dark:bg-slate-900 dark:border-slate-600"
            />
          </div>
          <div className="space-y-2">
            <Label className="dark:text-gray-300">Color</Label>
            <div className="flex gap-2 flex-wrap">
              {FOLDER_COLORS.map(color => (
                <button
                  key={color}
                  onClick={() => setFolderColor(color)}
                  className={`w-8 h-8 rounded-lg transition-all ${
                    folderColor === color ? 'ring-2 ring-offset-2 ring-gray-400 dark:ring-offset-slate-800 scale-110' : 'hover:scale-105'
                  }`}
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
          </div>
          
          {/* Danger Zone */}
          <div className="border-t dark:border-slate-700 pt-4 mt-4">
            <Label className="text-sm font-medium text-red-600 dark:text-red-400 mb-3 block">Danger Zone</Label>
            <Button
              variant="outline"
              size="sm"
              className="border-red-200 dark:border-red-900 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950"
              onClick={onDelete}
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Folder
            </Button>
            <p className="text-xs text-muted-foreground mt-2">Workspaces inside will be moved to root.</p>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="dark:border-slate-600 dark:text-gray-300">Cancel</Button>
          </DialogClose>
          <Button 
            onClick={onSave}
            disabled={loading || !folderName.trim()}
            className="bg-[#4A9CC7] hover:bg-[#3d8ab5]"
            data-testid="save-folder-btn"
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditFolderDialog;
